import { api } from "@/services/api";

import acceptInvitationEndpoint from "./accept-invitation";
import declineInvitationEndpoint from "./decline-invitation";
import declineUserInvitationEndpoint from "./decline-user-invitation";
import searchInvitationsUsersEndpoint from "./search-invitations-users.ts";
import searchUserInvitationsEndpoint from "./search-user-invitations";
import deleteInvitationUserEndpoint from "@/store/invitations/endpoints/delete-invitation.ts";
import resendInvitationUserEndpoint from "@/store/invitations/endpoints/resend-invitation.ts";

export const invitationsApi = api.injectEndpoints({
  endpoints: build => ({
    acceptInvitation: acceptInvitationEndpoint(build),
    declineInvitation: declineInvitationEndpoint(build),
    declineUserInvitation: declineUserInvitationEndpoint(build),
    deleteInvitation: deleteInvitationUserEndpoint(build),
    resendInvitation: resendInvitationUserEndpoint(build),
    searchInvitationsUsers: searchInvitationsUsersEndpoint(build),
    searchUserInvitations: searchUserInvitationsEndpoint(build),
  }),
});

export const {
  useAcceptInvitationMutation,
  useDeclineInvitationMutation,
  useDeclineUserInvitationMutation,
  useDeleteInvitationMutation,
  useResendInvitationMutation,
  useLazySearchInvitationsUsersQuery,
  useSearchUserInvitationsQuery,
} = invitationsApi;
